import _ from 'lodash';
import React, { useState } from 'react';
import { Button, Modal, Row } from 'react-bootstrap';
import Folders from './Folders';
import Files from './Files';
import Dropzone from '../Dropzone';
import RestrictedContent from '../../../global/RestrictedContent';
import { Permissions } from 'config/Constants';
import { useTranslation } from 'react-i18next';

export default function MediaSelectorModal({ onHide, onSubmit }) {
    const [selectedMedia, setSelectedMedia] = useState(null);
    const [selectedFolder, setSelectedFolder] = useState(null);
    const { t } = useTranslation('documents');

    return (
        <Modal id="media-selector-modal" show onHide={onHide} size="lg" scrollable>
            <Modal.Header closeButton>
                <Modal.Title>
                    {t('document.navbar.main.editor.left.blocks.types.fileBlock.fileModal.media')}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <ModalBody
                    selectedMedia={selectedMedia}
                    setSelectedMedia={setSelectedMedia}
                    selectedFolder={selectedFolder}
                    setSelectedFolder={setSelectedFolder}
                />
            </Modal.Body>

            <Modal.Footer>
                <Button variant="link" onClick={onHide}>
                    {t('btn.close')}
                </Button>
                <Button variant="primary" disabled={selectedMedia === null} onClick={handleSubmit}>
                    {t('document.navbar.main.editor.left.blocks.types.fileBlock.fileModal.btn.select')}
                </Button>
            </Modal.Footer>
        </Modal>
    );

    function handleSubmit() {
        onSubmit(selectedMedia);
    }
}

function ModalBody({ selectedMedia, setSelectedMedia, selectedFolder, setSelectedFolder }) {
    return (
        <Row>
            <div
                className="col-3 px-1 pt-4"
                style={{
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    left: 0,
                    width: '25%',
                    overflowY: 'auto',
                }}
            >
                <Folders selectedFolder={selectedFolder} setSelectedFolder={setSelectedFolder} />
            </div>
            <div
                className="col-9 pt-3"
                style={{
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    left: '25%',
                    width: '75%',
                    overflowY: 'scroll',
                }}
            >
                <RestrictedContent permission={Permissions.Media['Write.All']}>
                    <div className="mb-3">
                        <Dropzone
                            selectedFolderId={_.isObject(selectedFolder) ? selectedFolder.id : null}
                            onDropComplete={(files = []) => {
                                const lastFile = files.pop();

                                if (lastFile) {
                                    setSelectedMedia(lastFile);
                                }
                            }}
                        />
                    </div>
                </RestrictedContent>

                <Files
                    selectedMedia={selectedMedia}
                    setSelectedMedia={setSelectedMedia}
                    selectedFolder={selectedFolder}
                />
            </div>
        </Row>
    );
}
